import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Button from "./../../elements/Button";
import InputField from "./../../elements/Input";
import MasterService from "../../../service/MasterService";
import CommonService from "../../../service/CommonService";
import Select from "react-select";
import ModalPopup from "../../elements/Popup";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import CheckBox from "./../../elements/CheckBox";
import ViewIFDetailsHistory from "./ViewIFDetailsHistory";
import Noimage from '../../../webroot/images/noimage.svg';
import secureStorage from '../../../config/encrypt';
import ViewImage from "./ViewImage";
import { NumericFormat as NumberFormat } from "react-number-format";
import Accordion from './../../elements/Accordion';
import ViewPDF from "./ViewPDF";
import DealerVerificationMapping from "./DealerVerificationMapping";
class InventoryFundingDetails extends Component {
    constructor(props) {
        super(props);
        this.addNewAddressShow = this.addNewAddressShow.bind(this);
        this.addNewAddressHide = this.addNewAddressHide.bind(this);
        this.state = {
            basicDetails: props.basic_details || {},
            dealerIdHash: props.dealer_id_hash || '',
            loggedInuser: props.user_loggedin || 0,
            role_access: props.role_access || [],
            max:999999999999,
            ifSelectedOption: {},
            ifCategoryOptions: [],
            ifCategoryList: [],
            ifCategorySubOptions: {},

            ifHistoryDetailsPopup: false,

            ifDetailFormData: {},
            errors: {},
            loading: false,
            difDetail: [],
            difFinancier: [],
            img_url: "",
            show_image_modal: false,
            show_noc_modal: false,
            pdf_url: "",
            ifAllFinancierCategoryList: [],
            ifMultipleAddressList: [],
            updateAddressData: {},            
            addNewAddressHideShow:false,
            addNewAddressData:{dealer_id_hash: this.props.dealer_id_hash},
            is_dealer_noc_doc: 0, 
            haveOpenLeads: true,
            cityAllList: props.cityAllList || [],
            addOutletErrors:{},
            updateOutletErrors:{},         
            showDealerMappingModal: false,
            ifMappedApplicationObject: null
        };
    }

    componentDidMount = () => {
        if (this.state.cityAllList.length === 0) {
            let StateList = this.props.StateList;
            let cityAllList = this.props.cityAllList;
            let localityList = this.props.localityList || [];
            this.setState({ StateList: StateList, cityAllList: cityAllList, localityList: localityList });
        }
        this.getIFCategoryListAll();
        this.getIFAllCategoryDetails(this.state.dealerIdHash)
        this.getIFMultipleAddressDetails(this.state.dealerIdHash)
        this.getDIFDetail(this.state.dealerIdHash)
        this.getFinancierList()
        this.getOpenLoanData(this.state.dealerIdHash) 
        this.state.ifMultipleAddressList.forEach((val, index) => {
            if (val.state_id > 0) {                           
                this.handleStateOptionChange(index)(val.state_id,'state_id'); 
                this.handleCityOptionChange(index)(val.city_id,'city_id');                        
            }

        })       
    };



    componentWillReceiveProps(nextProps) {
        this.setState({
            basicDetails: nextProps.basic_details,
            dealerIdHash: nextProps.dealer_id_hash,
            loggedInuser: nextProps.user_loggedin,
            role_access: nextProps.role_access || [],
        });
        if (this.state?.cityAllList?.length === 0) {
            let StateList = nextProps.StateList;
            let cityAllList = nextProps.cityAllList;
            let localityList = nextProps.localityList || [];
            this.setState({ StateList: StateList, cityAllList: cityAllList, localityList: localityList });
        }
        this.state?.ifMultipleAddressList?.forEach((val, index) => {
            if (val.state_id > 0) {                           
                this.handleStateOptionChange(index)(val.state_id,'state_id'); 
                this.handleCityOptionChange(index)(val.city_id,'city_id');                        
            }
        })
    }  
    getOpenLoanData = async (dealerIdHash) => {
        this.setState({ loading: true })
        try {
            let response = await MasterService.post(`/dealer/dealer/get_open_loan_data`, { dealer_id_hash: dealerIdHash });
            if (response?.data?.status === 200) {
                if (response?.data?.data?.lead_list?.length === 0) {
                    this.setState({ haveOpenLeads: false })
                }
            } else {
                toast.error(response?.data?.message || `Error: Failed to call get_open_loan_data`)
            }

        } catch (error) {
            toast.error(error)
        } finally {
            this.setState({ loading: false })
        }
    }

    getDIFDetail = (dealerIdHash) => {
        this.setState({ loading: true });
        MasterService.post(`/dealer/inventory-funding/get_dif_info`, { dealer_id: dealerIdHash }).then((response) => {
            if (response && response.data && response.data.status === 200) {
                let difDetail = response.data.data;
                this.setState({ difDetail: difDetail });
                this.setState({ loading: false });
            } else {
                this.setState({ loading: false });
                toast.error(response.data.message);
            }
        });
    };
    getFinancierList = () => {
        this.setState({ loading: true });
        MasterService.post(`/dealer/inventory-funding/get_financier`, { }).then((response) => {
            if (response && response.data && response.data.status === 200) {
                let difFinancier = response.data.data;
                this.setState({ difFinancier: difFinancier });
                this.setState({ loading: false });
            } else {
                this.setState({ loading: false });
                toast.error(response.data.message);
            }
        });
    };
    getIFCategoryListAll = () => {
        this.setState({ loading: true });
        MasterService.post(`/dealer/inventory-funding/get_if_category_list_menu`, {}).then((response) => {
            if (response && response.data && response.data.status === 200) {
                let categoryList = response.data.data.categoryList;
                let categoryOptions = response.data.data.categoryOptions;                
                this.setState({ ifCategoryOptions: categoryOptions });
                this.setState({ ifCategoryList: categoryList });                
                this.getIFAllCategoryDetails(this.state.dealerIdHash)
                this.setState({ loading: false });
            } else {
                this.setState({ loading: false });
                toast.error(response.data.message);
            }
        });
    };

    saveIfCategoryDetails = (params) => {
        // this.state.loading = true;//need to remove
        this.setState({ loading: true });
        let updated_by = 0;
        let created_by = 0;
        let dealer_id = '';
        let priority_dealer = 0;

        let loginResponse = secureStorage.getItem('loginUserInfo');
        let loginuserid = loginResponse && loginResponse.data && loginResponse.data.user_data && loginResponse.data.user_data.user_id;
        if (this.state.loggedInuser && this.state.dealerIdHash) {
            updated_by = loginuserid
            created_by = loginuserid
            dealer_id = this.state.dealerIdHash;
        }

        if (this.state.ifDetailFormData && this.state.ifDetailFormData.priority_dealer) {
            priority_dealer = this.state.ifDetailFormData.priority_dealer
        }

        let category_name = ''
        if (this.state.ifSelectedOption && this.state.ifSelectedOption.label) {
            category_name = this.state.ifSelectedOption.label
        }
        params = { ...params,category_name,is_dealer_subscribe_for_dif : this.state.ifDetailFormData.is_dealer_subscribe_for_dif, updated_by: updated_by, created_by: created_by, dealer_id: dealer_id, priority_dealer: priority_dealer};

        if (this.validForm()) {
            MasterService.post('/dealer/inventory-funding/save_if_category_details', params)
            .then((response) => {
                if (response && response.data && response.data.status === 200) {
                    this.getIFAllCategoryDetails(this.state.dealerIdHash)
                    this.setState({ loading: false })
                    toast.success(response.data.message)
                } else {
                    this.setState({ loading: false })
                    toast.error(response.data.message)
                }
            }).catch((error) => {
                this.setState({ loading: false })
                toast.error(error);
            })
        } else {
            this.setState({ loading: false })
        }
    }

    validForm = () => {
        let fields = this.state.ifDetailFormData;
         let formIsValid = true;
         let errors = { ...this.state.errors };
         if (fields["is_default"] && !fields["is_active"]) {
            errors['Check_Is_Active'] =  this.props.t('dealerDetails.Inventory_Funding_Details.Check_Is_Active');
            formIsValid = false;
        }else{
            errors['Check_Is_Active'] =  "";
        }
        if (!fields["financier_id"]) {
            errors['financier_id'] =  this.props.t('dealerDetails.Inventory_Funding_Details.Select_Financier');
            formIsValid = false;
        }
        if (!fields["approved_limit"]) {
            errors['approved_limit'] =  this.props.t('dealerDetails.Inventory_Funding_Details.enter_drawing_power');
            formIsValid = false;
        }
        if (!fields["cashback"]) {
            errors['cashback'] =  this.props.t('dealerDetails.Inventory_Funding_Details.enter_cashback');
            formIsValid = false;
        }
        if (!fields["if_category_config_id"]) {
            errors['if_category_config_id'] =  this.props.t('dealerDetails.Inventory_Funding_Details.Select_Category');
            formIsValid = false;
        }
        if (!fields["facility_tenure"]) {
            errors['facility_tenure'] =  this.props.t('dealerDetails.Inventory_Funding_Details.enter_facility_tenure');
            formIsValid = false;
        }
        if (!fields["sanction_limit"]) {
            errors['sanction_limit'] =  this.props.t('dealerDetails.Inventory_Funding_Details.enter_sanction_limit');
            formIsValid = false;
        }
        if (!fields["per_car_limit"]) {
            errors['per_car_limit'] =  this.props.t('dealerDetails.Inventory_Funding_Details.enter_per_car_limit');
            formIsValid = false;
        }
        if (!fields["virtual_account_number"]) {
            errors['virtual_account_number'] =  this.props.t('dealerDetails.Inventory_Funding_Details.enter_virtual_account_number');
            formIsValid = false;
        }
        if (!fields["virtual_account_name"]) {
            errors['virtual_account_name'] =  this.props.t('dealerDetails.Inventory_Funding_Details.enter_virtual_account_name');
            formIsValid = false;
        }
        if (fields["approved_limit"] && fields["sanction_limit"]) {
            if (Number(fields["approved_limit"]) > Number(fields["sanction_limit"])) {
                errors['approved_limit'] = this.props.t('dealerDetails.Inventory_Funding_Details.dpltsl');
                formIsValid = false;
            } else {
                delete errors['approved_limit']
            }
        }

        if (fields["approved_limit"] && fields["per_car_limit"]) {
            if (Number(fields["approved_limit"]) <= Number(fields["per_car_limit"])) {
                errors['per_car_limit'] = this.props.t('dealerDetails.Inventory_Funding_Details.pclstdp');
                formIsValid = false;
            } else {
                delete errors['per_car_limit']
            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    getIFCategoryDetails = (dealerIdHash,financier_id) => {
        let self = this
        this.setState({ loading: true })
        MasterService.post('/dealer/inventory-funding/get_if_category_details', { dealer_id: dealerIdHash,financier_id:financier_id })
            .then((response) => {                
                if (response && response.data && response.data.status) {  
                    this.setState({ ifCategorySubOptions: {} });
                    let responseData = {is_dealer_subscribe_for_dif:'1'};                   
                    if(response && response.data && response.data.data && response.data.data.data && response.data.data.data.length){
                        responseData = response.data.data.data[0];
                        responseData.is_dealer_subscribe_for_dif='1';
                    } 
                                                                             
                    let if_category_config_id = 0
                     let value = self.state.ifCategoryOptions.filter(({ id }) => id === responseData.if_category_config_id)[0]
                    if(value && value.id){
                        if_category_config_id = value.id
                    }
                    let formData = {
                        if_category_config_id,
                        sanction_limit: responseData.sanction_limit,
                        approved_limit: responseData.approved_limit,
                        per_car_limit: responseData.per_car_limit,
                        facility_tenure: responseData.facility_tenure,
                        cashback: responseData.cashback,
                        financier_id:financier_id,
                        facility_code:responseData.facility_code,
                        is_default:responseData.is_default,
                        priority_dealer: responseData.priority_dealer,
                        is_dealer_subscribe_for_dif:responseData.is_dealer_subscribe_for_dif ? responseData.is_dealer_subscribe_for_dif : 0,
                        is_active:responseData.is_active,
                        virtual_account_name:responseData.virtual_account_name,
                        virtual_account_number:responseData.virtual_account_number
                    };
                    console.log("#################",responseData);
                    let [selectData] = this.state.ifCategoryList.filter(item => item.id === responseData.if_category_config_id)
                    if (selectData) {
                        let selectedOption = { id: selectData.id, label: selectData.category_name };
                        this.setState({ ifSelectedOption: selectedOption })
                        this.getCategorySubOptions(selectedOption);
                    }
                    this.setState({ ifDetailFormData: formData })
                    this.setState({ loading: false })
                } else {
                    this.setState({ loading: false })
                    toast.error(response.data.message)
                }
            }).catch((error) => {
                this.setState({ loading: false })
                toast.error(error)
            })
    }
    handleDownloadNocDoc = async () => {
        this.setState({ loading: true })
        let pdfData = await MasterService.download('/dealer/inventory-funding/download_if_noc_doc', { dealer_id: this.state.dealerIdHash }, 'arraybuffer')        
        const blob = new Blob([pdfData.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Employee_Commitment_Form.pdf';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.setState({ loading: false })
    }

    getIFAllCategoryDetails = (dealerIdHash) => {
        // eslint-disable-next-line no-unused-vars
        let self = this
        this.setState({ loading: true })
        MasterService.post('/dealer/inventory-funding/get_if_All_category_details', { dealer_id: dealerIdHash })
            .then(async (response) => {
                if (response && response.data && response.data.status) {
                    let responseData = response.data.data;
                    let tempFromData = { ...this.state.ifDetailFormData };
                    tempFromData['is_dealer_subscribe_for_dif'] = responseData.is_dealer_subscribe_for_dif;
                    this.setState({ ifMappedApplicationObject: Object.keys(responseData?.mapped_if_application_object).length ? responseData?.mapped_if_application_object : null })
                    this.setState({ is_dealer_noc_doc: responseData.is_dealer_noc_doc })
                    this.setState({ pdf_url: responseData.dealer_noc_doc_url })
                    this.setState({ ifDetailFormData: tempFromData })
                    this.setState({ ifAllFinancierCategoryList: responseData.all_financier_data })
                } else {
                    this.setState({ loading: false })
                    toast.error(response.data.message)
                }
            }).catch((error) => {
                this.setState({ loading: false })
                toast.error(error)
            })
    }
    getIFMultipleAddressDetails = (dealerIdHash) => {
        // eslint-disable-next-line no-unused-vars
        let self = this
        this.setState({ loading: true })
        MasterService.post('/dealer/inventory-funding/dif_address_list', { dealer_id_hash: dealerIdHash })
            .then((response) => {
                if (response && response.data && response.data.status) {
                    let responseData = response.data.data;                    
                    this.setState({ ifMultipleAddressList: responseData})
                    this.state.ifMultipleAddressList.forEach((val, index) => {
                        if (val.state_id > 0) {                           
                            this.handleStateOptionChange(index)(val.state_id,'state_id'); 
                            this.handleCityOptionChange(index)(val.city_id,'city_id');                        
                        }
            
                    })  
                    this.setState({ loading: false })
                } else {
                    this.setState({ loading: false })
                    toast.error(response.data.message)
                }
            }).catch((error) => {
                this.setState({ loading: false })
                toast.error(error)
            })
    }
    __numberWithCommas = (num) => {
        return CommonService.__numberWithCommaSeperator(num);
      };

    getCategorySubOptions = (selectedData) => {
        const interestedKeys = {
            provision_fee: { label: 'Provision Fee', type: '%' },
            interest_fee: { label: 'Interest Fee', type: '%' },
            renewal_fee: { label: 'Renewal Fee', type: '%' },
            admin_fee: { label: 'Admin Fee', type: '%' },
            loan_tenure: { label: 'Loan Tenure', type: 'Days' },
            renewal_time: { label: 'Renewal Time', type: 'Days' },
            penalty_interest: { label: 'Penalty Interest', type: '%' },
            penalty_fee: { label: 'Penalty Fee', type: '' },
            ltv: { label: 'LTV', type: '%' },
            category_cashback: { label: 'Category Cashback', type: '%' },
            risk_premium_fee: { label: 'Premium Fee', type: '%' },
            repeat_order_fee: { label: 'Repeat Order Fee', type: '%' },
            bpkb_switch_fee: { label: 'BPKB Switch Fee', type: '%' },
            principal_repayment_fee: { label: 'Principal Repayment Fee', type: '%' },

          };
        let categorySubOptions = [];
        if (this.state.ifCategoryList && this.state.ifCategoryList.length) {
            for (const data of this.state.ifCategoryList) {
                if (selectedData.id === data.id) {
                    for (const [key, value] of Object.entries(data)) {
                        if (interestedKeys[key] && value !== null && value !== undefined) {
                            const FEE_CONFIG = {
                                admin_fee: {
                                    feeTypeKey: 'admin_fee_type',
                                },
                                renewal_fee: {
                                    feeTypeKey: 'renewal_fee_type',
                                },
                                risk_premium_fee: {
                                    feeTypeKey: 'risk_premium_type',
                                },
                                repeat_order_fee: {
                                    feeTypeKey: 'repeat_order_fee_type',
                                },
                                bpkb_switch_fee: {
                                    feeTypeKey: 'bpkb_switch_fee_type',
                                },
                                principal_repayment_fee: {
                                    feeTypeKey: 'principal_repayment_fee_type',
                                }
                            };
                            if(key in FEE_CONFIG){
                                const feeType = data[FEE_CONFIG[key].feeTypeKey];
                                let valueData = feeType === 1 ? `${value} ${interestedKeys[key].type}` : `${value}`
                                categorySubOptions.push({
                                    id: key,
                                    label: `${interestedKeys[key].label}`,
                                    value: `${valueData}`,
                                });
                            }else if(key === 'penalty_fee'){
                                categorySubOptions.push({
                                    id: key,
                                    label: `${interestedKeys[key].label}`,
                                    value: `${this.__numberWithCommas(value)} ${interestedKeys[key].type}`,
                                });
                            }else{
                                categorySubOptions.push({
                                    id: key,
                                    label: `${interestedKeys[key].label}`,
                                    value: `${value} ${interestedKeys[key].type}`,
                                });
                            }
                        }else{
                            if (key === 'ltv') {
                              categorySubOptions.push({
                                id: key,
                                label: `${interestedKeys[key].label}`,
                                value: value == null ? '-' : `${value} ${interestedKeys[key].type}`,
                              });
                            }
                        }
                    }
                }
            }
        }
        this.setState({ ifCategorySubOptions: categorySubOptions });
    };

    handleCategoryChange = (data, name) => {
        let tempFromData = { ...this.state.ifDetailFormData };
        const errors = this.state.errors;
        tempFromData['if_category_config_id'] = data.id;
        delete errors['if_category_config_id'];

        this.setState({ ifSelectedOption: data });
        this.setState({ ifDetailFormData: tempFromData })
        this.getCategorySubOptions(data);
    };    

    handleChangeFinancier = (data, name) => {
        let tempFromData = { ...this.state.ifDetailFormData };
        const errors = this.state.errors;
        tempFromData['financier_id'] = data.id;
        delete errors['financier_id'];
        if(data.id){
            this.getIFCategoryDetails(this.state.dealerIdHash,data.id)
        }else{
            this.setState({ ifDetailFormData: {} })
        }
        
        //this.setState({ ifSelectedOption: data });
        this.setState({ ifDetailFormData: tempFromData })
    };
    handleSubmitForm = (event, data) => {
        event.preventDefault();
        this.saveIfCategoryDetails(data);
    }

    handleInputChange = (event, name) => {
        let formData = { ...this.state.ifDetailFormData };
        const errors = this.state.errors;
        let value = event.target ? event.target.value : event.value;
        if(name === 'cashback'){
            const validated = value.match(/^(\d*\.{0,1}\d{0,2}$)/)
            if(validated){
                formData[name] = value;
            } 
        } else if (['sanction_limit', 'approved_limit', 'per_car_limit'].includes(name)) {
            const validated = value.match(/^(?!0(\.0+)?$)\d*(\.\d{0,2})?$/);
            formData[name] = validated ? value : '';
        } else {
            formData[name] = value;
        }
        delete errors[name];
        this.setState({ ifDetailFormData: formData })
    }

    handleChecked = (event, name) => {
        let formData = { ...this.state.ifDetailFormData };
        formData[name] = event.target.checked ? 1 : 0;
        this.setState({ ifDetailFormData: formData })
    }

    closeIfHistoryDetailsModel = () => {
        this.setState({ ifHistoryDetailsPopup: false });
    };

    handleIfDetailsHistory = () => {
        this.setState({ ifHistoryDetailsPopup: true })
    }
    handleCashbackInterestSync = (isCashbackInterestSync, dealer_id) => {
        this.setState({ loading: true });
        let cashbackInterestSyncActivated = isCashbackInterestSync === '1' ? '0' : '1';
        if (dealer_id > 0) {
            MasterService.post('dealer/dealer/cashback-interest-sync', { dealer_id: dealer_id, is_cashback_interest_sync: cashbackInterestSyncActivated })
                .then((response) => {
                    if (response.status === 200 && response.data.status === 200) {
                        let basicDetails = { ...this.state.basicDetails }
                        basicDetails.is_cashback_interest_sync = cashbackInterestSyncActivated
                        this.setState({
                            basicDetails: basicDetails
                        });
                        toast.success(response.data.message);
                    } else {
                        toast.error(response.data.message);
                    }
                }).catch((error) => {
                    toast.error(error.message);
                });
        } else {
            let basicDetails = { ...this.state.basicDetails }
            basicDetails.is_cashback_interest_sync = cashbackInterestSyncActivated
            this.setState({
                basicDetails: basicDetails
            });
        }
        this.setState({ loading: false });
    }

    handleDIF = (isDIF, dealer_id) => {
        if (this?.state?.haveOpenLeads && this.state?.ifDetailFormData?.is_dealer_subscribe_for_dif === '1') {
            toast.error("Dealer have open leads");
            return;
        }
        this.setState({ loading: true });
        let dif_data = this.state.ifDetailFormData
        let isDIFActivated = isDIF === '1' ? '0' : '1';
        if(dealer_id > 0 && dif_data && dif_data.approved_limit && dif_data.sanction_limit && dif_data.if_category_config_id){
            let obj = {
                if_category_config_id:dif_data.if_category_config_id,
                is_dealer_subscribe_for_dif : isDIFActivated,
                dealer_id
            }
            MasterService.post('/dealer/dealer/update_dif', obj)
            .then(response => {
                if(response.data.status === 200){
                    let if_details = {...this.state.ifDetailFormData}
                     if_details.is_dealer_subscribe_for_dif = response.data.data.is_dealer_subscribe_for_dif
                    this.setState({
                        ifDetailFormData:if_details
                    });
                }else{
                     toast.error(response.data.message);
                }
            })
            .catch(error => console.log(error))
        }else{
            let if_details = {...this.state.ifDetailFormData}
            if_details.is_dealer_subscribe_for_dif = isDIFActivated
            this.setState({
                ifDetailFormData:if_details
            });
        }
        this.setState({ loading: false });
     }
    humanize = (str) => {
        var i, frags = str.split('_');
        for (i=0; i<frags.length; i++) {
          frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
        }
        let final_str = frags.join(' ').replace(' Url', '');
        if (final_str === 'Photo Of Banner') {
          final_str = 'Showroom Photo with Banner';
        } else if (final_str === 'Dealer Selfie') {
          final_str = 'Selfie Photo Owner';
        } else if (final_str === 'Bpkb On Hand') {
          final_str = 'Stock with BPKB Photo';
        } else if (final_str === 'Dealer Stock') {
          final_str = 'Dealer Stock/Inventory Photo';
        }
         return final_str
      }

    handleImageClick = (img_url) => {
        if (img_url && img_url !== "") {
            this.setState({ img_url })
            this.showImageModal()
        }
    }

    closeImageModal = () => {
        this.setState({ show_image_modal: false });
    };

    showImageModal = () => {
        this.setState({ show_image_modal: true });
    };

    closeNocModal = () => {
        this.setState({ show_noc_modal: false });
    };

    showNocModal = () => {
        this.setState({ show_noc_modal: true });
    };
    handleStateOptionChange = (idx) => (ovalue,type) => {
        type = (typeof type == 'object') ? type.name : type
        let stateid = 0;
        if (typeof ovalue == 'number') {
            stateid = ovalue;
        } else {
            stateid = ovalue?.id;
        }
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.ifMultipleAddressList[idx][type] = stateid;
        console.log("this.state.cityAllList_",this.state.cityAllList);
        let citylist = this.state.cityAllList;
        const result = citylist && citylist?.length > 0 ? citylist.filter(cityinfo => cityinfo.state_id === stateid) : [];       
        if (this.state.ifMultipleAddressList[idx].error && this.state.ifMultipleAddressList[idx].error[type]) {
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.ifMultipleAddressList[idx].error[type] = '';
        }

        let obj = {};        
        obj = { ['filteredcity_' + idx]: result, ['filteredlocality_' + idx]: [], ['filtereddistrict_' + idx]: [] };        
        this.setState(obj, () => {
              console.log('city changes','filteredcity_'+idx,result)
              console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$"+idx,this.state['filteredcity_' + idx])
        })              
    }  
    handleCityOptionChange = (idx) => (ovalue,type) => {
        type = (typeof type == 'object') ? type.name : type
        let cityid = 0;
        if (typeof ovalue == 'number') {
            cityid = ovalue;
        } else {
            cityid = ovalue?.id;
        }    
        let tempSetData=[...this.state.ifMultipleAddressList]; 
        tempSetData[idx][type]= cityid; 
        this.setState({"ifMultipleAddressList":tempSetData});                
        if (this.state.ifMultipleAddressList[idx].error && this.state.ifMultipleAddressList[idx].error[type]) {
            // eslint-disable-next-line react/no-direct-mutation-state
            this.state.ifMultipleAddressList[idx].error[type] = '';
        }       
    }
    addNewAddressStateOptionChange = () => (ovalue,type) => {
        type = (typeof type == 'object') ? type.name : type
        let stateid = 0;
        if (typeof ovalue == 'number') {
            stateid = ovalue;
        } else {
            stateid = ovalue?.id;
        }
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.addNewAddressData[type] = stateid;
        //console.log("this.state.cityAllList_",this.state.cityAllList);
        let citylist = this.state.cityAllList;
        const result = citylist.filter(cityinfo => cityinfo.state_id === stateid);       
        

        let obj = {};        
        // eslint-disable-next-line no-useless-computed-key
        obj = { ['filteredcity']: result, ['filteredlocality']: [], ['filtereddistrict']: [] };        
        this.setState(obj, () => {
              console.log('city changes','filteredcity',result)              
        })              
    }
    addNewAddressCityOptionChange = (idx) => (ovalue,type) => {
        type = (typeof type == 'object') ? type.name : type
        let cityid = 0;
        if (typeof ovalue == 'number') {
            cityid = ovalue;
        } else {
            cityid = ovalue?.id;
        }    
        let tempSetData={...this.state.addNewAddressData}; 
        tempSetData[type]= cityid; 
        this.setState({"addNewAddressData":tempSetData});                             
    }
    updateDifOutletAddressDetails = async (event) => {
        let { ifMultipleAddressList, updateAddressData } = this.state;
        var index = Number(event.target.attributes.getNamedItem('data-index').value);        
            this.setState({ loading: true })
            if (this.validateUpdateOutletAddress(index)) {
            updateAddressData.dealer_id = ifMultipleAddressList[index].dealer_id;
            updateAddressData.if_showroom_id = ifMultipleAddressList[index].if_showroom_id;
            updateAddressData.is_dif_multiple_address = ifMultipleAddressList[index].is_dif_multiple_address;
            updateAddressData.address_line1 = ifMultipleAddressList[index].address_line1;         
            updateAddressData.address_line2 = ifMultipleAddressList[index].address_line2;
            updateAddressData.state_id = ifMultipleAddressList[index].state_id;
            updateAddressData.city_id = ifMultipleAddressList[index].city_id;
            updateAddressData.locality_id = ifMultipleAddressList[index].locality_id;            
            updateAddressData.pincode = ifMultipleAddressList[index].pincode;
            updateAddressData.latitude = ifMultipleAddressList[index].latitude;
            updateAddressData.longitude = ifMultipleAddressList[index].longitude;            
            MasterService.post('/dealer/inventory-funding/save_dif_address', updateAddressData).then((response) => {
                if (response.status === 200 && response.data.status === 200) {
                    toast.success(this.props.t('dealerDetails.Basic_Employee_Details.Updated_Successfully'));
                    this.getDealerEmployeeDetails();
                    this.setState({ loading: false })
                } else {
                    
                    this.setState({ loading: false })
                    toast.error(response.data.message);
                } 
            }).catch((error) => {
                toast.error(error)
                this.setState({ loading: false })
            })
        }else{
            this.setState({ loading: false })
        }
        
    }
    addDifOutletAddressDetails = async (event) => {
        let tempAddNewAddressData = {...this.state.addNewAddressData};    
        let addNewAddressData={};      
            this.setState({ loading: true })
            addNewAddressData.dealer_id_hash=this.props.dealer_id_hash                       
            addNewAddressData.address_line1 = tempAddNewAddressData.address_line1;         
            addNewAddressData.address_line2 = tempAddNewAddressData.address_line2;
            addNewAddressData.state_id = tempAddNewAddressData.state_id;
            addNewAddressData.city_id = tempAddNewAddressData.city_id;
            addNewAddressData.locality_id = tempAddNewAddressData.locality_id;            
            addNewAddressData.pincode = tempAddNewAddressData.pincode;
            addNewAddressData.latitude = tempAddNewAddressData.latitude;
            addNewAddressData.longitude = tempAddNewAddressData.longitude;
            if (this.validateOutletAddress()) {
            MasterService.post('/dealer/inventory-funding/save_dif_address', addNewAddressData).then((response) => {
                if (response.status === 200 && response.data.status === 200) {
                    this.setState({ addNewAddressHideShow: false, loading: false });
                    this.setState(() => ({ addNewAddressData:{} }))     
                    this.setState(() => ({ addNewAddressData:{dealer_id_hash: this.props.dealer_id_hash} }))  
                    toast.success(this.props.t('dealerDetails.Inventory_Funding_Details.Address_page.saved_successfully'));                                     
                    this.getIFMultipleAddressDetails(this.state.dealerIdHash)                                           
                } else {
                    
                    this.setState({ loading: false })
                    toast.error(response.data.message);
                } 
            }).catch((error) => {
                toast.error(error)
                this.setState({ loading: false })
            })
        }else{
            this.setState({ loading: false }) 
        }
        
    }
    validateOutletAddress = () => {
        let fields = this.state.addNewAddressData;
         let formIsValid = true;
         let addOutletErrors = {};        
        if (!fields["address_line1"]) {
            addOutletErrors['address_line1'] =  this.props.t('dealerDetails.Inventory_Funding_Details.Address_page.address1_required');
            formIsValid = false;
        }
        if (!fields["state_id"]) {
            addOutletErrors['state_id'] =  this.props.t('dealerDetails.Inventory_Funding_Details.Address_page.state_required');
            formIsValid = false;
        }  
        if (!fields["city_id"]) {
            addOutletErrors['city_id'] =  this.props.t('dealerDetails.Inventory_Funding_Details.Address_page.city_required');
            formIsValid = false;
        }  
        if (!fields["pincode"]) {
            addOutletErrors['pincode'] =  this.props.t('dealerDetails.Inventory_Funding_Details.Address_page.pin_required');
            formIsValid = false;
        }          
        this.setState({ addOutletErrors: addOutletErrors });
        return formIsValid;
    }
    validateUpdateOutletAddress = (idx) => {
        let fields = this.state.ifMultipleAddressList[idx];      
         let formIsValid = true;
         let updateOutletErrors = {};           
        if (!fields["address_line1"]) {            
            updateOutletErrors['address_line1'+idx] =  this.props.t('dealerDetails.Inventory_Funding_Details.Address_page.address1_required');
            formIsValid = false;
        }
        if (!fields["state_id"]) {
            updateOutletErrors['state_id'+idx] =  this.props.t('dealerDetails.Inventory_Funding_Details.Address_page.state_required');
            formIsValid = false;
        }  
        if (!fields["city_id"]) {
            updateOutletErrors['city_id'+idx] =  this.props.t('dealerDetails.Inventory_Funding_Details.Address_page.city_required');
            formIsValid = false;
        }  
        if (!fields["pincode"]) {
            updateOutletErrors['pincode'+idx] =  this.props.t('dealerDetails.Inventory_Funding_Details.Address_page.pin_required');
            formIsValid = false;
        }          
        this.setState({ updateOutletErrors: updateOutletErrors });
        return formIsValid;
    }
    deleteEmployeeDetails(id) {
        this.setState({ loading: true })
        const deleteEmpObject = {
            "if_showroom_id": id,
            "dealer_id_hash": this.props.dealer_id_hash
        }
        MasterService.post('/dealer/inventory-funding/remove_dif_address', deleteEmpObject).then((response) => {
                if (response.status === 200 && response.data.status === 200) {
                    toast.success(this.props.t('dealerDetails.Inventory_Funding_Details.Address_Deleted'));
                    this.getIFMultipleAddressDetails(this.state.dealerIdHash)
                } else {
                    this.setState({ loading: false })
                    toast.error(response.data.errors ? response.data.errors[0] : 'Error')
                }
            }).catch((error) => {

                toast.error(error)
                this.setState({ loading: false })
            });
    }
    handleInputchange = (idx) => event => {
        let inpname = event.target.name;
        let value = event.target.value;
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.ifMultipleAddressList[idx][inpname] = value;
        let tempIfMultipleAddressList = this.state.ifMultipleAddressList;
        this.setState({ ifMultipleAddressList: tempIfMultipleAddressList }, () => {
            //    console.log('state change on change of input');
        })
    }
    handleAddAddressInputchange = () => event => {
        let inpname = event.target.name;
        let value = event.target.value;
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.addNewAddressData[inpname] = value;
        let tempIfMultipleAddressList = this.state.addNewAddressData;
        this.setState({ addNewAddressData: tempIfMultipleAddressList }, () => {
                console.log('############',this.state.addNewAddressData);
        })
    }
    addNewAddressShow() {        
        this.setState({ addNewAddressHideShow: true });
    }

    addNewAddressHide() {
        this.setState({ addNewAddressHideShow: false });
    }
    toggleDealerMappingModal = () => {
        this.setState(prevState => ({
            showDealerMappingModal: !prevState.showDealerMappingModal
        }));
    }

    handleMappingSuccess = () => {
        this.toggleDealerMappingModal();
        this.getIFCategoryListAll();
        this.getIFAllCategoryDetails(this.state.dealerIdHash)
        this.getDIFDetail(this.state.dealerIdHash)
        this.getFinancierList()
        this.getOpenLoanData(this.state.dealerIdHash)
    }
    render() {     
    // let { errors ,ifCategoryList, difDetail ,role_access } = this.state; //need to remove
       let { errors, difDetail ,role_access,basicDetails,addNewAddressData,addOutletErrors,updateOutletErrors } = this.state; 
       // eslint-disable-next-line no-unused-vars
       const { StateList , districtAllList } = this.props;
       
        return (
            <div>
                <h1>{this.props.t("dealerDetails.Inventory_Funding_Details.Inventory_Funding")}
                     <span className="f12">
                        { (basicDetails.gcd_code) ? <span> ({basicDetails.organization} - {basicDetails.gcd_code})</span> : '' }
                     </span>
                     <span className="f12">
                        {
                            (basicDetails.vendor_id) ? <span> Vendor ID - {basicDetails.vendor_id}</span> : ''
                        }
                    </span>
                </h1>
                <form
                    className={this.state.loading ? "text-left os-animation animated fadeInDown loading" : "text-left os-animation animated fadeInDown"}
                    data-os-animation="fadeInDown"
                    data-os-animation-delay="0s"
                    method="post"
                    id="basicdetail_form"
                    onSubmit={(e) => { this.handleSubmitForm(e, this.state.ifDetailFormData) }}
                >
                    <div className="card">
                        <div className="card-heading">
                            <h2 className="card-title">{this.props.t("dealerDetails.Inventory_Funding_Details.Inventory_Funding_Service")}
                            { role_access.includes("inventory_funding_activate") &&
                                <label className="switch-btn btn-link" style={{"fontSize": "16px", "marginRight": "150px"}}>                                                    
                                    <input className="switch-btn"  name={"active"} type="checkbox" 
                                    onChange={() => {
                                        this.handleDIF(this.state.ifDetailFormData.is_dealer_subscribe_for_dif,this.state.basicDetails.id)
                                    }}
                                    checked={(this.state.ifDetailFormData.is_dealer_subscribe_for_dif === '1') ? true : false} />
                                    <div className="slider round"></div>
                                    <span className="switch-label"></span>
                                    {this.state.ifDetailFormData.is_dealer_subscribe_for_dif === '1' ? this.props.t('dealerDetails.Inventory_Funding_Details.Activated') : this.props.t('dealerDetails.Inventory_Funding_Details.Not_Activated')}
                                </label> 
                            }
                           

                                        {/* <span className="info-icon" style={{ 
                                            display: "inline-block", 
                                            width: "16px", 
                                            height: "16px", 
                                            borderRadius: "50%", 
                                            backgroundColor: "#6c757d", 
                                            color: "white", 
                                            textAlign: "center", 
                                            lineHeight: "16px", 
                                            fontSize: "12px", 
                                            marginRight: "8px", 
                                            cursor: "pointer",
                                            position: "relative"
                                        }} title="When enabled cashback will follow interest calculation when enabled; otherwise both will be calculated separately.">
                                            i
                                        </span>
                                        Cashback & Interest Sync
                                        <label className="switch-btn btn-link" style={{ "fontSize": "16px" }}>
                                            <input className="switch-btn" name={"cashback_interest_sync"} type="checkbox"
                                                onChange={() => {
                                                    this.handleCashbackInterestSync(this.state.basicDetails.is_cashback_interest_sync, this.state.basicDetails.id)
                                                }}
                                                checked={(this.state.basicDetails.is_cashback_interest_sync == '1') ? true : false} />
                                            <div className="slider round"></div>
                                            <span className="switch-label"></span>
                                            {this.state.basicDetails.is_cashback_interest_sync == '1' ? 'Activated' : 'Not Activated'}
                                        </label>
                                         */}
                                         
                                          </h2>

                            {this.state.ifDetailFormData.is_dealer_subscribe_for_dif === '1' ? <a className="noc_doc_download" href={() => false} onClick={() => { this.toggleDealerMappingModal() }} title="Mapping" rel="noopener noreferrer">{this.props.t("dealerDetails.Inventory_Funding_Details.Dealer_Verification_Mapping")} </a> : ""}
                            {this.state.ifDetailFormData.is_dealer_subscribe_for_dif === '1' && this.state.is_dealer_noc_doc === 1 ? <a className="noc_doc_download" href={() => false} onClick={() => { this.showNocModal() }} title="Document" rel="noopener noreferrer">View Dealer NOC Concent </a>:""}
                        </div>

                             
                        { this.state.ifDetailFormData.is_dealer_subscribe_for_dif === '1' ? <>
                        <div className="card-body">
                            <div className="row">
                            <div className="col-sm-2">                                   
                                    <label>{this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Select_Financier")}</label>
                                    <Select
                                        components={{ IndicatorSeparator:() => null }}
                                        id="financier_id"
                                        options={this.state.difFinancier}
                                        onChange={(data) => {
                                            this.handleChangeFinancier(data, "financier_id");
                                        }}
                                        name="financier_id"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Select_Financier")}
                                        value={this.state.difFinancier.filter(({ id }) => +id === +this.state.ifDetailFormData.financier_id) || 0}
                                        getOptionLabel={({ financier_name }) => financier_name}
                                        getOptionValue={({ id }) => id}
                                    />
                                    {
                                       (errors && errors.financier_id) ? <span className="error show">{errors.financier_id}</span> : ''
                                    }
                                </div>
                                <div className="pull-left col-sm-4">

                                    <label>{this.props.t("dealerDetails.Inventory_Funding_Details.Select_Category")}</label>
                                    <Select
                                        components={{ IndicatorSeparator:() => null }}
                                        id="if_category_config_id"
                                        options={this.state.ifCategoryOptions}
                                        onChange={(data) => {
                                            this.handleCategoryChange(data, "if_category_config_id");
                                        }}
                                        name="if_category_config_id"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Select_Category")}
                                        value={this.state.ifCategoryOptions.filter(({ id }) => id === this.state.ifDetailFormData.if_category_config_id) || 0}
                                        getOptionLabel={({ label }) => label}
                                        getOptionValue={({ id }) => id}
                                    />
                                    {
                                       (errors && errors.if_category_config_id) ? <span className="error show">{errors.if_category_config_id}</span> : ''
                                    }
                                </div>
                                <div className="gs_nowrapcontrol pull-right col-sm-1"> 
                                    <CheckBox
                                        type="checkbox"
                                        name="is_active"
                                        id="is_active"
                                        value={this.state.ifDetailFormData.is_active ? this.state.ifDetailFormData.is_active : 0}
                                        checked={this.state.ifDetailFormData.is_active ? 1 : 0}
                                        label={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.is_active")}
                                        onChange={(e) => { this.handleChecked(e, 'is_active') }}
                                    />   
                                    {
                                       (errors && errors.Check_Is_Active) ? <span className="error show">{errors.Check_Is_Active}</span> : ''
                                    }  
                                    </div>
                                    <div className="pull-right">                                                                                                 
                                    <CheckBox
                                        type="checkbox"
                                        name="is_default"
                                        id="is_default"
                                        value={this.state.ifDetailFormData.is_default ? this.state.ifDetailFormData.is_default : 0}
                                        checked={this.state.ifDetailFormData.is_default ? 1 : 0}
                                        label={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.is_default")}
                                        onChange={(e) => { this.handleChecked(e, 'is_default') }}
                                    />   
                                                                                             
                                    <Button
                                        btnClass="btn btn-secondary mrg-r30 "
                                        title={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.View_History")}
                                        type="button"
                                        onClick={(e) => {this.handleIfDetailsHistory(e)}}
                                    />

                                </div>

                            </div>

                                <div className="row" style={{ marginBottom: "17px" }}>
                                    {this.state.ifCategorySubOptions &&
                                        this.state.ifCategorySubOptions.length > 0 && (
                                            <>
                                                {/* First Row */}
                                                <div className="row">
                                                    {this.state.ifCategorySubOptions.slice(0, 10).map((item, idx) => (
                                                        <div className="col-sm-1" key={idx}>
                                                            <span>
                                                                <span>{item.value}</span><br />
                                                                <span>{item.label}</span>
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>

                                                {/* Second Row */}
                                                {this.state.ifCategorySubOptions.length > 10 && (
                                                    <div className="row" style={{ marginTop: "10px" }}>
                                                        {this.state.ifCategorySubOptions.slice(10).map((item, idx) => (
                                                            <div className="col-sm-1" key={idx}>
                                                                <span>
                                                                    <span>{item.value}</span><br />
                                                                    <span>{item.label}</span>
                                                                </span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </>
                                        )}
                                </div>


                            <div className="row mrg-b15">
                                <div className="col-sm-4">
                                    <label>{`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Sanction_Limit")} (Rp)`}<span className="required" style={{ color: 'red', marginLeft: "4px" }}>*</span></label>
                                    <NumberFormat
                                        className="form-control mrg-b5"
                                        thousandSeparator={"."}
                                        decimalSeparator={","}
                                        type="text"
                                        name="sanction_limit"
                                        id="sanction_limit"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Sanction_Limit")}
                                        value={this.state.ifDetailFormData.sanction_limit ? this.state.ifDetailFormData.sanction_limit : ""}
                                        onValueChange={(e) => { this.handleInputChange(e, "sanction_limit") }}
                                    />
                                    {
                                       (errors && errors.sanction_limit) ? <span className="error show">{errors.sanction_limit}</span> : ''
                                    }
                                </div>
                                <div className="col-sm-4">
                                    <label>{`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Drawing_Power")} (Rp)`}<span className="required" style={{ color: 'red', marginLeft: "4px" }}>*</span></label>
                                    <NumberFormat
                                        className="form-control"
                                        thousandSeparator={"."}
                                        decimalSeparator={","}
                                        type="text"
                                        name="approved_limit"
                                        id="approved_limit"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Drawing_Power")}
                                        value={this.state.ifDetailFormData.approved_limit ? this.state.ifDetailFormData.approved_limit : ""}
                                        onValueChange={(e) => { this.handleInputChange(e, "approved_limit") }}
                                    />
                                    {
                                       (errors && errors.approved_limit) ? <span className="error show">{errors.approved_limit}</span> : ''
                                    }
                                </div>
                                <div className="col-sm-4">
                                    <label>{`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Per_Car_Limit")} (Rp)`}<span className="required" style={{ color: 'red', marginLeft: "4px" }}>*</span></label>
                                    <NumberFormat
                                        className="form-control"
                                        thousandSeparator={"."}
                                        decimalSeparator={","}
                                        type="text"
                                        name="per_car_limit"
                                        id="per_car_limit"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Per_Car_Limit")}
                                        value={this.state.ifDetailFormData.per_car_limit ? this.state.ifDetailFormData.per_car_limit : ""}
                                        onValueChange={(e) => { this.handleInputChange(e, "per_car_limit") }}
                                    />
                                    {
                                       (errors && errors.per_car_limit) ? <span className="error show">{errors.per_car_limit}</span> : ''
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <InputField
                                        type="number"
                                        min="0"
                                        max={this.state.max}
                                        name="facility_tenure"
                                        id="facility_tenure"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Facility_Tenure")}
                                        value={this.state.ifDetailFormData.facility_tenure ? this.state.ifDetailFormData.facility_tenure : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Facility_Tenure")} (Months)`}
                                        onChange={(e) => { this.handleInputChange(e, "facility_tenure") }}
                                        required={true}
                                    />
                                    {
                                       (errors && errors.facility_tenure) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{errors.facility_tenure}</span> : ''
                                    }
                                </div>
                                <div className="col-sm-4">
                                    <InputField
                                        type="number"
                                        min="0"
                                        max="100"
                                        name="cashback"
                                        id="cashback"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Cashback")}
                                        value={this.state.ifDetailFormData.cashback ? this.state.ifDetailFormData.cashback : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Cashback")} (%)`}
                                        onChange={(e) => { this.handleInputChange(e, "cashback") }}
                                        required={true}
                                    />
                                    {
                                       (errors && errors.cashback) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{errors.cashback}</span> : ''
                                    }
                                </div>
                                <div className="col-sm-4">
                                    <InputField
                                        type="number"                                                 
                                        name="virtual_account_number"
                                        id="virtual_account_number"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.virtual_account_number")}
                                        value={this.state.ifDetailFormData.virtual_account_number ? this.state.ifDetailFormData.virtual_account_number : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.virtual_account_number")}`}
                                        onChange={(e) => { this.handleInputChange(e, "virtual_account_number") }}
                                        required={true}
                                    />
                                    {
                                       (errors && errors.virtual_account_number) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{errors.virtual_account_number}</span> : ''
                                    }
                                </div>
                                <div className="col-sm-4">
                                    <InputField
                                        type="text"                                                 
                                        name="virtual_account_name"
                                        id="virtual_account_name"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.virtual_account_name")}
                                        value={this.state.ifDetailFormData.virtual_account_name ? this.state.ifDetailFormData.virtual_account_name : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.virtual_account_name")}`}
                                        onChange={(e) => { this.handleInputChange(e, "virtual_account_name") }}
                                        required={true}
                                    />
                                    {
                                       (errors && errors.virtual_account_name) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{errors.virtual_account_name}</span> : ''
                                    }
                                </div>
                                <div className="col-sm-4">
                                    <InputField
                                        type="text"                                                 
                                        name="facility_code"
                                        id="facility_code"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.facility_code")}
                                        value={this.state.ifDetailFormData.facility_code ? this.state.ifDetailFormData.facility_code : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.facility_code")}`}
                                        onChange={(e) => { this.handleInputChange(e, "facility_code") }}
                                        required={false}
                                    />
                                    {
                                       (errors && errors.facility_code) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{errors.facility_code}</span> : ''
                                    }
                                </div>
                                <div className="col-sm-4">
                                    <br />
                                    <CheckBox
                                        type="checkbox"
                                        name="priority_dealer"
                                        id="priority_dealer"
                                        value={this.state.ifDetailFormData.priority_dealer ? this.state.ifDetailFormData.priority_dealer : ""}
                                        checked={this.state.ifDetailFormData.priority_dealer ? true : false}
                                        label={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Priority_Dealer")}
                                        onChange={(e) => { this.handleChecked(e, 'priority_dealer') }}
                                    />
                                </div>                               
                            </div>
                        </div>
                        <div className="card-footer text-center">
                            <NavLink to={this.props.prevpage} className="btn btn-default mrg-r30">
                                {" "}
                                <i className="ic-arrow_back"></i> {this.props.t("dealerDetails.Outlet_Details_master.Previous")}{" "}
                            </NavLink>
                            { role_access.includes("inventory_funding_details_save") &&
                                <Button
                                    btnClass="btn btn-primary mrg-r30"
                                    title={this.props.t("dealerDetails.Inventory_Funding_Details.Save_Details")}
                                    type="submit"
                                />
                            }
                            {/* {basicinfo && basicinfo.id && basicinfo.id > 0 ? (
                                <NavLink to={this.props.nextpage} className="btn btn-default">
                                    {this.props.t("dealerDetails.Outlet_Details_master.Next")} <i className="ic-arrow_forward"></i>
                                </NavLink>
                            ) : (
                                ""
                            )} */}
                        </div>
                        </>: <div className="inventory_inactive_funding">
                            <img src={Noimage} alt=""></img>
                            <span>{this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.IF_NOT_ACTIVATED")}</span>
                            </div>}
                    </div>
                    </form>
                    {this.state.ifAllFinancierCategoryList.length > 0 ?
                        <div className="card">
                            <div className="card-heading">
                                <h2 className="card-title">{this.props.t("dealerDetails.Inventory_Funding_Details.Inventory_Funding_Detail")}</h2>
                            </div>
                        </div> : ''}
                    {this.state.ifAllFinancierCategoryList.length > 0 ?
                            this.state.ifAllFinancierCategoryList.map((ifFinancierCategory, index) =>
                                <Accordion key={ifFinancierCategory.id} title={(ifFinancierCategory.is_default && ifFinancierCategory.is_active)?ifFinancierCategory.financier_name +" - Active - (Default)":((ifFinancierCategory.is_default))?ifFinancierCategory.financier_name +" - (Default)":((ifFinancierCategory.is_active))?ifFinancierCategory.financier_name +" -Active":ifFinancierCategory.financier_name}>                                  
                                    <div className="card-body">
                            <div className="row">
                            <div className="col-sm-2">                                   
                                    <label>{this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Select_Financier")}</label>
                                    <Select
                                        components={{ IndicatorSeparator:() => null }}
                                        id="financier_id"
                                        options={this.state.difFinancier}
                                        onChange={(data) => {
                                            //this.handleChangeFinancier(data, "financier_id");
                                        }}
                                        name="financier_id"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Select_Financier")}
                                        value={this.state.difFinancier.filter(({ id }) => +id === +ifFinancierCategory.financier_id) || 0}
                                        getOptionLabel={({ financier_name }) => financier_name}
                                        getOptionValue={({ id }) => id}
                                    />
                                    {
                                       (errors && errors.financier_id) ? <span className="error show">{errors.financier_id}</span> : ''
                                    }
                                </div>
                                <div className="pull-left col-sm-4">

                                    <label>{this.props.t("dealerDetails.Inventory_Funding_Details.Select_Category")}</label>
                                    <Select
                                        components={{ IndicatorSeparator:() => null }}
                                        id="if_category_config_id"
                                        options={this.state.ifCategoryOptions}
                                        onChange={(data) => {
                                            //this.handleCategoryChange(data, "if_category_config_id");
                                        }}
                                        name="if_category_config_id"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Select_Category")}
                                        value={this.state.ifCategoryOptions.filter(({ id }) => id === ifFinancierCategory.if_category_config_id) || 0}
                                        getOptionLabel={({ label }) => label}
                                        getOptionValue={({ id }) => id}
                                    />
                                    {
                                      // (errors && errors.if_category_config_id) ? <span className="error show">{errors.if_category_config_id}</span> : ''
                                    }                                                                
                                </div>                               
                                <div className="pull-right mrg-r30"> 
                                <CheckBox
                                        type="checkbox"
                                        name="is_active"
                                        id="is_active"
                                        value={ifFinancierCategory.is_active ? ifFinancierCategory.is_active : 0}
                                        checked={ifFinancierCategory.is_active ? 1 : 0}
                                        label={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.is_active")}
                                        //onChange={(e) => { this.handleChecked(e, 'is_active') }}
                                    />                                                                    
                                    {/* <CheckBox
                                        type="checkbox"
                                        name="is_default"
                                        id="is_default"
                                        value={ifFinancierCategory.is_default ? ifFinancierCategory.is_default : 0}
                                        checked={ifFinancierCategory.is_default ? 1 : 0}
                                        label={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.is_default")}
                                        onChange={(e) => { this.handleChecked(e, 'is_default') }}
                                    />                                                               */}
                                    {/* <Button
                                        btnClass="btn btn-secondary mrg-r30 "
                                        title={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.View_History")}
                                        type="button"
                                        onClick={(e) => {this.handleIfDetailsHistory(e)}}
                                    /> */}

                                </div>

                            </div>
                            <div className="row" style={{"marginBottom": "17px","marginTop": "17px"}}>                                                                                
                                <div className="col-sm-1">
                                    <span>
                                        <span> {ifFinancierCategory.interest_fee ? ifFinancierCategory.interest_fee : "-"} </span><br></br>
                                        <span> Interest Fee</span>
                                    </span>
                                </div> 
                                <div className="col-sm-1">
                                    <span>
                                        <span> {ifFinancierCategory.provision_fee ? ifFinancierCategory.provision_fee : "-"} </span><br></br>
                                        <span> Provision Fee</span>
                                    </span>
                                </div>
                                <div className="col-sm-1">
                                    <span>
                                        <span> {ifFinancierCategory.admin_fee ? ifFinancierCategory.admin_fee : "-"} </span><br></br>
                                        <span> Admin Fee</span>
                                    </span>
                                </div>                                                        
                                <div className="col-sm-1">
                                    <span>
                                        <span> {ifFinancierCategory.renewal_fee ? ifFinancierCategory.renewal_fee : "-"} </span><br></br>
                                        <span> Renewal Fee</span>
                                    </span>
                                </div>
                                <div className="col-sm-1">
                                    <span>
                                        <span> {ifFinancierCategory.renewal_time ? ifFinancierCategory.renewal_time : "-"} </span><br></br>
                                        <span> Renewal Time</span>
                                    </span>
                                </div>
                                <div className="col-sm-1">
                                    <span>
                                        <span> {ifFinancierCategory.loan_tenure ? ifFinancierCategory.loan_tenure : "-"} </span><br></br>
                                        <span> Loan Tenure</span>
                                    </span>
                                </div>   
                                <div className="col-sm-1">
                                    <span>
                                        <span> {ifFinancierCategory.penalty_interest ? ifFinancierCategory.penalty_interest : "-"} </span><br></br>
                                        <span> Penalty Interest</span>
                                    </span>
                                </div>   
                                <div className="col-sm-1">
                                    <span>
                                        <span> {ifFinancierCategory.penalty_fee ? ifFinancierCategory.penalty_fee : "-"} </span><br></br>
                                        <span> Penalty Fee</span>
                                    </span>
                                </div>   
                                <div className="col-sm-1">
                                    <span>
                                        <span> {ifFinancierCategory.ltv ? ifFinancierCategory.ltv : "-"} </span><br></br>
                                        <span> LTV</span>
                                    </span>
                                </div>  
                                <div className="col-sm-2">
                                    <span>
                                        <span> {ifFinancierCategory.category_cashback ? ifFinancierCategory.category_cashback : "-"} </span><br></br>
                                        <span>Category Cashback</span>
                                    </span>
                                </div>                                                                               
                            </div>                            
                            {/* <div className="row" style={{"marginBottom": "17px"}}>
                                    {this.state.ifCategorySubOptions &&
                                        this.state.ifCategorySubOptions.length > 0 &&
                                        this.state.ifCategorySubOptions.map((item, idx) => {
                                            return (
                                                <div className="col-sm-1">
                                                <span>
                                                    <span> {item.value} </span><br></br>
                                                    <span> {item.label} </span>
                                                </span>
                                                </div>
                                            );
                                        })}
                            </div> */}

                            <div className="row mrg-b15">
                                <div className="col-sm-4">
                                    <label>{`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Sanction_Limit")} (Rp)`}<span className="required" style={{ color: 'red', marginLeft: "4px" }}>*</span></label>
                                    <NumberFormat
                                        className="form-control mrg-b5"
                                        thousandSeparator={"."}
                                        decimalSeparator={","}
                                        type="text"
                                        name="sanction_limit"
                                        id="sanction_limit"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Sanction_Limit")}
                                        value={ifFinancierCategory.sanction_limit ? ifFinancierCategory.sanction_limit : ""}
                                        //onValueChange={(e) => { this.handleInputChange(e, "sanction_limit") }}
                                    />
                                    {
                                       //(errors && errors.sanction_limit) ? <span className="error show">{errors.sanction_limit}</span> : ''
                                    }
                                </div>
                                <div className="col-sm-4">
                                    <label>{`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Drawing_Power")} (Rp)`}<span className="required" style={{ color: 'red', marginLeft: "4px" }}>*</span></label>
                                    <NumberFormat
                                        className="form-control"
                                        thousandSeparator={"."}
                                        decimalSeparator={","}
                                        type="text"
                                        name="approved_limit"
                                        id="approved_limit"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Drawing_Power")}
                                        value={ifFinancierCategory.approved_limit ? ifFinancierCategory.approved_limit : ""}
                                        //onValueChange={(e) => { this.handleInputChange(e, "approved_limit") }}
                                    />
                                    {
                                       //(errors && errors.approved_limit) ? <span className="error show">{errors.approved_limit}</span> : ''
                                    }
                                </div>
                                <div className="col-sm-4">
                                    <label>{`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Per_Car_Limit")} (Rp)`}<span className="required" style={{ color: 'red', marginLeft: "4px" }}>*</span></label>
                                    <NumberFormat
                                        className="form-control"
                                        thousandSeparator={"."}
                                        decimalSeparator={","}
                                        type="text"
                                        name="per_car_limit"
                                        id="per_car_limit"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Per_Car_Limit")}
                                        value={ifFinancierCategory.per_car_limit ? ifFinancierCategory.per_car_limit : ""}
                                        //onValueChange={(e) => { this.handleInputChange(e, "per_car_limit") }}
                                    />
                                    {
                                       //(errors && errors.per_car_limit) ? <span className="error show">{errors.per_car_limit}</span> : ''
                                    }
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <InputField
                                        type="number"
                                        min="0"
                                        max={this.state.max}
                                        name="facility_tenure"
                                        id="facility_tenure"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Facility_Tenure")}
                                        value={ifFinancierCategory.facility_tenure ? ifFinancierCategory.facility_tenure : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Facility_Tenure")} (Months)`}
                                        //onChange={(e) => { this.handleInputChange(e, "facility_tenure") }}
                                        //required={true}
                                    />
                                    {
                                       //(errors && errors.facility_tenure) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{errors.facility_tenure}</span> : ''
                                    }
                                </div>
                                <div className="col-sm-4">
                                    <InputField
                                        type="number"
                                        min="0"
                                        max="100"
                                        name="cashback"
                                        id="cashback"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Cashback")}
                                        value={ifFinancierCategory.cashback ? ifFinancierCategory.cashback : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Cashback")} (%)`}
                                        //onChange={(e) => { this.handleInputChange(e, "cashback") }}
                                        //required={true}
                                    />
                                    {
                                       //(errors && errors.cashback) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{errors.cashback}</span> : ''
                                    }
                                </div>
                                <div className="col-sm-4">
                                    <br />
                                    <CheckBox
                                        type="checkbox"
                                        name="priority_dealer"
                                        id="priority_dealer"
                                        value={ifFinancierCategory.priority_dealer ? ifFinancierCategory.priority_dealer : ""}
                                        checked={ifFinancierCategory.priority_dealer ? true : false}
                                        label={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.Priority_Dealer")}
                                        //onChange={(e) => { this.handleChecked(e, 'priority_dealer') }}
                                    />
                                </div>                               
                            </div>
                            <div className="row">
                                <div className="col-sm-4">
                                    <InputField 
                                        type="text"                                      
                                        name="v_account_number"
                                        id="v_account_number"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.virtual_account_number")}
                                        value={ifFinancierCategory.virtual_account_number ? ifFinancierCategory.virtual_account_number : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.virtual_account_number")}`}                                        
                                    />                                   
                                </div>
                                <div className="col-sm-4">
                                    <InputField
                                        type="text"                                       
                                        name="v_account_name"
                                        id="v_account_name"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.virtual_account_name")}
                                        value={ifFinancierCategory.virtual_account_name ? ifFinancierCategory.virtual_account_name : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.virtual_account_name")}`}                                      
                                    />                                  
                                </div>

                                <div className="col-sm-4">
                                    <InputField
                                        type="text"                                       
                                        name="facility_code"
                                        id="facility_code"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.facility_code")}
                                        value={ifFinancierCategory.facility_code ? ifFinancierCategory.facility_code : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Details_Page.facility_code")}`}                                      
                                    />                                  
                                </div>
                            </div>
                        </div>
                                </Accordion>
                            ) : ''}
                    {this.state.ifMultipleAddressList.length > 0 ?
                        <div className="card add-multi-address">                            
                            <div className="card-heading">
                                <h2 className="card-title">{this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.outlet_address")}</h2>
                            </div> 
                            {
                                this.state.ifMultipleAddressList.length < 6 ? <button className="btn btn-success" onClick={this.addNewAddressShow}>{this.props.t('dealerDetails.Inventory_Funding_Details.add_another_if_address')}</button> : ''
                            }                           
                        </div> : ''}
                        {this.state.addNewAddressHideShow ?
                        <Accordion title={this.props.t('dealerDetails.Inventory_Funding_Details.Address_page.add_outlet_address')} active="true" delete="true">                                  
                                    <div className="card-body">  
                                    <div className="row">
                                        <div className="col-sm-12 text-right">
                                            
                                                 <button className="btn btn-link pull-right" onClick={() => { if (window.confirm(this.props.t('dealerDetails.Basic_Employee_Details.Confirm_Delete'))) this.addNewAddressHide() }} ><i className="ic-delete"></i> {this.props.t('dealerDetails.Basic_Employee_Details.Delete')}</button>
                                            
                                        </div>
                                    </div>                                                                                                                     
                            <div className="row">
                                <div className="col-sm-4">
                                    <InputField 
                                        type="text"                                      
                                        name="address_line1"
                                        id="address_line1"
                                        onChange={this.handleAddAddressInputchange()}
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.address_line1")}
                                        value={addNewAddressData.address_line1 ? addNewAddressData.address_line1 : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.address_line1")}`}                                        
                                        required={true}
                                    />   
                                    {
                                       (addOutletErrors && addOutletErrors.address_line1) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{addOutletErrors.address_line1}</span> : ''
                                    }                                
                                </div>
                                <div className="col-sm-4">
                                    <InputField
                                        type="text"                                       
                                        name="address_line2"
                                        id="address_line2"
                                        onChange={this.handleAddAddressInputchange()}
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.address_line2")}
                                        value={addNewAddressData.address_line2 ? addNewAddressData.address_line2 : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.address_line2")}`}                                      
                                    />                                  
                                </div>  
                                <div className="col-sm-4">
                                    <InputField
                                        type="text"                                       
                                        name="pincode"
                                        id="pincode"
                                        onChange={this.handleAddAddressInputchange()}
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.pincode")}
                                        value={addNewAddressData.pincode ? addNewAddressData.pincode : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.pincode")}`} 
                                        required={true}                                     
                                    />  
                                    {
                                       (addOutletErrors && addOutletErrors.pincode) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{addOutletErrors.pincode}</span> : ''
                                    }                                 
                                </div>                             
                            </div>
                            <div className="row">
                            <div className="col-sm-4">                                   
                                    <label>{this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.state")}<span className="required" style={{ color: 'red' }}>*</span></label>
                                    <Select
                                        components={{ IndicatorSeparator:() => null }}
                                        id="state_id"
                                        options={StateList}
                                        onChange={this.addNewAddressStateOptionChange('','state_id')}
                                        name="state_id"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.state")}
                                        value={StateList && StateList.filter(({ id }) => +id === +this.state.addNewAddressData.state_id)}
                                        getOptionLabel={({name }) =>name}
                                        getOptionValue={({ id }) => id}
                                    />
                                    {
                                       (addOutletErrors && addOutletErrors.state_id) ? <span className="error show">{addOutletErrors.state_id}</span> : ''
                                    }
                                </div>
                                <div className="pull-left col-sm-4">

                                    <label>{this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.city")}<span className="required" style={{ color: 'red' }}>*</span></label>
                                    <Select
                                        components={{ IndicatorSeparator:() => null }}
                                        id="city_id"
                                        options={this.state['filteredcity'] || []}
                                        onChange={this.addNewAddressCityOptionChange('','city_id')}
                                        name="city_id"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.city")}                                        
                                        value={(this.state['filteredcity'] || []).filter(v => +v.id === +addNewAddressData.city_id)}
                                        getOptionLabel={({ name }) => name}
                                        getOptionValue={({ id }) => id}
                                    />
                                   {
                                       (addOutletErrors && addOutletErrors.city_id) ? <span className="error show">{addOutletErrors.city_id}</span> : ''
                                    }                                                               
                                </div>    
                                <div className="col-sm-4">
                                    <InputField 
                                        type="text"                                      
                                        name="latitude"
                                        id="latitude"
                                        onChange={this.handleAddAddressInputchange()}
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.latitude")}
                                        value={addNewAddressData.latitude ? addNewAddressData.latitude : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.latitude")}`}                                        
                                    />                                   
                                </div>                           
                            </div>
                            <div className="row">                                
                                <div className="col-sm-4">
                                    <InputField
                                        type="text"                                       
                                        name="longitude"
                                        id="longitude"
                                        onChange={this.handleAddAddressInputchange()}
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.longitude")}
                                        value={addNewAddressData.longitude ? addNewAddressData.longitude : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.longitude")}`}                                      
                                    />                                  
                                </div>                               
                            </div>
                            <div className="row text-center">
                                            
                                                 <button className="btn btn-primary" onClick={this.addDifOutletAddressDetails}>{this.props.t('dealerDetails.Basic_Employee_Details.Save')}</button>
                                            
                            </div>
                        </div>
                                </Accordion>:""}

         {this.state.ifMultipleAddressList.length > 0 ?         
                            this.state.ifMultipleAddressList.map((ifMultipleAddress, idx) =>
                                <Accordion key={ifMultipleAddress.if_showroom_id} title={(ifMultipleAddress.is_dif_multiple_address === 1)?ifMultipleAddress.address_line1:ifMultipleAddress.address_line1+"(Dealer's Address)"}>                                  
                                    <div className="card-body">  
                                    <div className="row">
                                        <div className="col-sm-12 text-right">
                                            {
                                                ifMultipleAddress.is_dif_multiple_address === 1 ? <button className="btn btn-link pull-right" onClick={() => { if (window.confirm(this.props.t('dealerDetails.Basic_Employee_Details.Confirm_Delete'))) this.deleteEmployeeDetails(ifMultipleAddress.if_showroom_id) }} ><i className="ic-delete"></i> {this.props.t('dealerDetails.Basic_Employee_Details.Delete')}</button>: ''
                                            }
                                        </div>
                                    </div>                                                                                                                     
                            <div className="row">
                                <div className="col-sm-4">
                                    <InputField 
                                        type="text"                                      
                                        name="address_line1"
                                        id="address_line1"
                                        onChange={this.handleInputchange(idx)}
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.address_line1")}
                                        value={ifMultipleAddress.address_line1 ? ifMultipleAddress.address_line1 : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.address_line1")}`}                                        
                                        required={true}
                                    />    
                                    {
                                       (updateOutletErrors && updateOutletErrors["address_line1"+idx]) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{updateOutletErrors["address_line1"+idx]}</span> : ''
                                    }                               
                                </div>
                                <div className="col-sm-4">
                                    <InputField
                                        type="text"                                       
                                        name="address_line2"
                                        id="address_line2"
                                        onChange={this.handleInputchange(idx)}
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.address_line2")}
                                        value={ifMultipleAddress.address_line2 ? ifMultipleAddress.address_line2 : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.address_line2")}`}                                      
                                    />                                                                       
                                </div>  
                                <div className="col-sm-4">
                                    <InputField
                                        type="text"                                       
                                        name="pincode"
                                        id="pincode"
                                        onChange={this.handleInputchange(idx)}
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.pincode")}
                                        value={ifMultipleAddress.pincode ? ifMultipleAddress.pincode : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.pincode")}`}                                      
                                        required={true}
                                    />  
                                    {
                                       (updateOutletErrors && updateOutletErrors["pincode"+idx]) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{updateOutletErrors["pincode"+idx]}</span> : ''
                                    }                                 
                                </div>                             
                            </div>
                            <div className="row">
                            <div className="col-sm-4">                                   
                                    <label>{this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.state")}<span className="required" style={{ color: 'red' }}>*</span></label>
                                    <Select
                                        components={{ IndicatorSeparator:() => null }}
                                        id="state_id"
                                        options={StateList}
                                        onChange={this.handleStateOptionChange(idx,'state_id')}
                                        name="state_id"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.state")}
                                        value={StateList && StateList.filter(({ id }) => +id === +ifMultipleAddress.state_id)}
                                        getOptionLabel={({name }) =>name}
                                        getOptionValue={({ id }) => id}
                                    />
                                    {
                                       (updateOutletErrors && updateOutletErrors["state_id"+idx]) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{updateOutletErrors["state_id"+idx]}</span> : ''
                                    }
                                </div>
                                <div className="pull-left col-sm-4">

                                    <label>{this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.city")}<span className="required" style={{ color: 'red' }}>*</span></label>
                                    <Select
                                        components={{ IndicatorSeparator:() => null }}
                                        id="city_id"
                                        options={this.state['filteredcity_' + idx] || []}
                                        onChange={this.handleCityOptionChange(idx,'city_id')}
                                        name="city_id"
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.city")}                                        
                                        value={(this.state['filteredcity_' + idx] || []).filter(v => +v.id === +ifMultipleAddress.city_id)}
                                        getOptionLabel={({ name }) => name}
                                        getOptionValue={({ id }) => id}
                                    />
                                    {
                                       (updateOutletErrors && updateOutletErrors["city_id"+idx]) ? <span className="error show" style={{"marginTop": "-13px","lineHeight": "1px"}}>{updateOutletErrors["city_id"+idx]}</span> : ''
                                    }                                                                
                                </div>    
                                <div className="col-sm-4">
                                    <InputField 
                                        type="text"                                      
                                        name="latitude"
                                        id="latitude"
                                        onChange={this.handleInputchange(idx)}
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.latitude")}
                                        value={ifMultipleAddress.latitude ? ifMultipleAddress.latitude : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.latitude")}`}                                        
                                    />                                   
                                </div>                           
                            </div>
                            <div className="row">                                
                                <div className="col-sm-4">
                                    <InputField
                                        type="text"                                       
                                        name="longitude"
                                        id="longitude"
                                        onChange={this.handleInputchange(idx)}
                                        placeholder={this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.longitude")}
                                        value={ifMultipleAddress.longitude ? ifMultipleAddress.longitude : ""}
                                        label={`${this.props.t("dealerDetails.Inventory_Funding_Details.Address_page.longitude")}`}                                      
                                    />                                  
                                </div>                               
                            </div>
                            <div className="row text-center">
                                            {
                                                ifMultipleAddress.is_dif_multiple_address === 1 ? <button className="btn btn-primary" data-index={idx} onClick={this.updateDifOutletAddressDetails}>{this.props.t('dealerDetails.Basic_Employee_Details.Update')}</button>: ''
                                            }
                            </div>
                        </div>
                                </Accordion>
                            ) : ''}
                    {difDetail && Object.keys(difDetail).length > 0 &&
                        <div className="card">
                            {/* <div className="card-heading">
                                <h2 className="card-title">{this.props.t("dealerDetails.Inventory_Funding_Details.Inventory_Funding_Detail")}</h2>
                            </div> */}
                            <div className="card-body">
                                <div className="row">
                                    <div className="pull-left col-sm-12 inventory_funding_detail">
                                        <h3>Basic Details</h3>
                                        <ul>
                                            <li>
                                                <span>Start Of Business</span>
                                                <label>{difDetail.start_of_business?difDetail.start_of_business:"-"}</label>
                                            </li>
                                            <li>
                                                <span>Average Units Sold per Month</span>
                                                <label>{difDetail.average_unit_sold_per_month?difDetail.average_unit_sold_per_month:"-"}</label>
                                            </li>
                                            <li>
                                                <span>Ownership Type</span>
                                                <label>{difDetail.ownership_type?this.humanize(difDetail.ownership_type):"-"}</label>
                                            </li>
                                            <li>
                                                <span>No. of UCF Transactions</span>
                                                <label>{difDetail.no_of_ucf_transaction?difDetail.no_of_ucf_transaction:"-"}</label>
                                            </li>
                                            <li>
                                                <span>BPKB Copy on Hand</span>
                                                <label>{difDetail.bpkb_copy_on_hand?difDetail.bpkb_copy_on_hand:"-"}</label>
                                            </li>
                                            <li>
                                                <span>Residential address dif from KTP</span>
                                                <label>{difDetail.residential_address_dif_from_ktp?"Yes":"No"}</label>
                                            </li>
                                            <li>
                                                <span>Residential Address</span>
                                                <label>{difDetail.residential_address?difDetail.residential_address:"-"}</label>
                                            </li>
                                            <li>
                                                <span>Pincode</span>
                                                <label>{difDetail.pincode?difDetail.pincode:"-"}</label>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="pull-left col-sm-12 inventory_funding_detail">
                                        <h3>Credit Line</h3>
                                        <ul >
                                            <li className="w-100">
                                                <span>Existing Credit Line</span>
                                                <label>{difDetail.existing_credit_line ? "Yes" : "No"}</label>
                                            </li>
                                           
                                            {difDetail.existing_credit_line === 1 &&
                                                <div className="w-100">
                                                    {difDetail.credit_lines && difDetail.credit_lines.length > 0 && difDetail.credit_lines.map((element, index) => (
                                                        <div className="funding-detail-with-img" key={index}>
                                                            <ul>
                                                                <li>
                                                                    <span>Financier Name</span>
                                                                    <label>{element.financier_name ? element.financier_name : "-"}</label>
                                                                </li>
                                                                <li>
                                                                    <span>Interest Fee</span>
                                                                    <label>{element.interest_fee ? element.interest_fee : "-"}</label>
                                                                </li>
                                                                <li>
                                                                    <span>Admin Fee</span>
                                                                    <label>{element.admin_fee ? element.admin_fee : "-"}</label>
                                                                </li>
                                                                <li>
                                                                    <span>Provision Fee</span>
                                                                    <label>{element.provision_fee ? element.provision_fee : "-"}</label>
                                                                </li>
                                                                <li>
                                                                    <span>Tenure</span>
                                                                    <label>{element.tenure ? element.tenure : "-"}</label>
                                                                </li>
                                                                {element.agreement_doc_url && element.agreement_doc_url.length > 0 &&
                                                                    <li>
                                                                        <span>Agreement DOC</span>
                                                                        {element.agreement_doc_url && element.agreement_doc_url.length > 0 && element.agreement_doc_url.map((img, img_ind) => (
                                                                            <div className="funding-img">
                                                                                {  img && img.includes('.pdf?') ? <a href={img} target="_blank" rel="noreferrer" download> <i className="ic-pdf-file icons-normal"></i>  View File </a> : <li onClick={()=>this.handleImageClick(img)}>{img && <img key={img_ind} src={img} alt="" />}</li> }
                                                                            </div>
                                                                        ))}
                                                                    </li>
                                                                }
                                                            </ul>
                                                        </div>
                                                    ))}
                                                </div>
                                            }
                                        </ul>
                                        {difDetail.documents && difDetail.documents["2"] && Object.keys(difDetail.documents["2"]).length > 0 && Object.keys(difDetail.documents["2"]).map((ele, index) => (
                                            <ul>
                                                <li className="w-100" key={index} >
                                                    <span>{this.humanize(ele)}</span>
                                                    <div className="funding-img">
                                                        {difDetail.documents["2"][ele] && difDetail.documents["2"][ele].length > 0 && difDetail.documents["2"][ele].map((img, img_ind) => (
                                                            <li onClick={()=>this.handleImageClick(img.doc_url)}>{img.doc_url && <img key={img_ind} src={img.doc_url} alt="" />}</li>
                                                        ))}
                                                     </div>
                                                </li>
                                            </ul>
                                        ))}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="pull-left col-sm-12 inventory_funding_detail">
                                        <h3>Other Details</h3>
                                        {difDetail.documents && difDetail.documents["3"] && Object.keys(difDetail.documents["3"]).length > 0 && Object.keys(difDetail.documents["3"]).map((ele, index) => (
                                            <ul>
                                                <li className="w-100" key={index} >
                                                    <span>{this.humanize(ele)}</span>
                                                    <div className="funding-img">
                                                    {difDetail.documents["3"][ele] && difDetail.documents["3"][ele].length > 0 && difDetail.documents["3"][ele].map((img, img_ind) => (
                                                       <li onClick={()=>this.handleImageClick(img.doc_url)}>{img.doc_url && <img key={img_ind} src={img.doc_url} alt="" />}</li>
                                                    ))}
                                                     </div>
                                                </li>
                                            </ul>
                                        ))}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="pull-left col-sm-12 inventory_funding_detail">
                                        <h3>Business Details</h3>
                                        <ul>
                                            <li>
                                                <span>Business License Type</span>
                                                <label>{difDetail.business_license_type?difDetail.business_license_type.toUpperCase():"-"}</label>
                                            </li>
                                        </ul>
                                        {difDetail.documents && difDetail.documents["4"] && Object.keys(difDetail.documents["4"]).length > 0 && Object.keys(difDetail.documents["4"]).map((ele, index) => (
                                            <ul>
                                                <li className="w-100" key={index} >
                                                    <span>{this.humanize(ele)}</span>
                                                    {difDetail.documents["4"][ele] && difDetail.documents["4"][ele].length > 0 && difDetail.documents["4"][ele].map((img, img_ind) => (
                                                      <div className="funding-img">
                                                       <li onClick={()=>this.handleImageClick(img.doc_url)}>{img.doc_url && <img key={img_ind} src={img.doc_url} alt="" />}</li>
                                                       </div>
                                                    ))}
                                                </li>
                                            </ul>
                                        ))}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="pull-left col-sm-12 inventory_funding_detail">
                                        <h3>Upload Other Photos Detail</h3>
                                        {difDetail.documents && difDetail.documents["5"] && Object.keys(difDetail.documents["5"]).length > 0 && Object.keys(difDetail.documents["5"]).map((ele, index) => (
                                            <ul>
                                                <li className="w-100" key={index} >
                                                    <span>{this.humanize(ele)}</span>
                                                    <div className="funding-img">
                                                    {difDetail.documents["5"][ele] && difDetail.documents["5"][ele].length > 0 && difDetail.documents["5"][ele].map((img, img_ind) => (
                                                    
                                                      <li onClick={()=>this.handleImageClick(img.doc_url)}>{img.doc_url && <img key={img_ind} src={img.doc_url} alt="" />}</li>
                                                      
                                                    ))}
                                                    </div>
                                                
                                                </li>
                                            </ul>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
               
                {this.state.ifHistoryDetailsPopup === false ? null : (
                    <ModalPopup
                        id="if_view_details_history"
                        className="modal ViewHistory data-table"
                        //title={`${this.state.ifSelectedOption.label} - Category History`}
                        title={`Category History`}
                        modalClose={this.closeIfHistoryDetailsModel}
                    >
                        <ViewIFDetailsHistory
                            dealerIdHash={this.state.dealerIdHash}
                            categoryName={this.state.ifSelectedOption.label}
                            formData={this.state.formData}
                        />

                    </ModalPopup>
                )}
                {this.state.show_image_modal === false ? null :
                    <ModalPopup id="show_image" className="modal show_image" modalClose={this.closeImageModal}>
                        <ViewImage modalClose={this.closeImageModal} image_url={this.state.img_url}/>
                        <button className="btn btn-primary">Download NOC</button>
                    </ModalPopup>
                }
                {this.state.show_noc_modal === false ? null :
                    <ModalPopup id="show_image" className="modal show_image" modalClose={this.closeNocModal}>
                        <ViewPDF modalClose={this.closeNocModal} pdf_url={this.state.pdf_url} />
                    </ModalPopup>
                }
                {this.state.showDealerMappingModal && (
                    <ModalPopup
                        id="dealer_verification_mapping"
                        className="modal ViewHistory data-table"
                        title="Dealer Verification Mapping"
                        modalClose={this.toggleDealerMappingModal}
                    >
                        <DealerVerificationMapping
                            onSuccess={this.handleMappingSuccess}
                            basicDetails={this.state.basicDetails}
                            ifMappedApplicationObject={this.state.ifMappedApplicationObject}
                        />
                    </ModalPopup>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth_token: state.authToken,
        user_loggedin: state.userLoggedIn,
        dealer_id: state.dealer_id,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateStateIntoRedux: (actionType, stateData) => dispatch({ type: actionType, componentState: stateData }),
    };
};

export default withTranslation("dealers")(connect(mapStateToProps, mapDispatchToProps)(InventoryFundingDetails));
